<template>
  <div class="hosOrder">
    <h3>消息详情<span @click="complain">投诉</span> <el-button class="btn_top" @click="open" type="primary">查看详情</el-button> </h3>
    <div class="tail">
      <span>订单跟踪：</span>
      <div>
        <p v-if="createdTime1(ticketList.orderStatus)"><span class="time">{{createdTime1(ticketList.orderStatus)}}</span><span>{{orderStatus1(ticketList.orderStatus)}}</span></p>
        <p v-if="createdTime2(ticketList.orderStatus)"><span class="time">{{createdTime2(ticketList.orderStatus)}}</span><span>{{orderStatus2(ticketList.orderStatus)}}</span></p>
        <p v-if="createdTime3(ticketList.orderStatus)"><span class="time">{{createdTime3(ticketList.orderStatus)}}</span><span>{{orderStatus3(ticketList.orderStatus)}}</span></p>
        <p v-if="createdTime4(ticketList.orderStatus)"><span class="time">{{createdTime4(ticketList.orderStatus)}}</span><span>{{orderStatus4(ticketList.orderStatus)}}</span></p>
        <p v-if="createdTime5(ticketList.orderStatus)"><span class="time">{{createdTime5(ticketList.orderStatus)}}</span><span>{{orderStatus5(ticketList.orderStatus)}}</span></p>
        <p v-if="createdTime6(ticketList.orderStatus)"><span class="time">{{createdTime6(ticketList.orderStatus)}}</span><span>{{orderStatus6(ticketList.orderStatus)}}</span></p>
      </div>
    </div>
    <div class="info">
      <div>
        <h5>出行信息</h5>
        <table>
          <tr>
            <td>出行方式</td>
            <td><span>{{ticketList.travelMode}}</span>{{ticketList.seatName}}</td>
          </tr>
          <tr>
            <td>出行日期</td>
            <td>{{ticketList.departureDate}}</td>
          </tr>
          <tr>
            <td>出发地</td>
            <td>{{ticketList.departurePlace}}</td>
          </tr>
          <tr>
            <td>目的地</td>
            <td>{{ticketList.destinationPlace}}</td>
          </tr>
          <tr>
            <td>车次</td>
            <td>{{ticketList.trainNumber}}</td>
          </tr>
        </table>
      </div>
      <div>
        <h5>其他信息</h5>
        <table>
          <tr>
            <td>姓名</td>
            <td>{{ticketList.name}}</td>
          </tr>
          <tr>
            <td>手机</td>
            <td>{{ticketList.phone}}</td>
          </tr>
          <tr>
            <td>身份证号码</td>
            <td>{{ticketList.idCard}}</td>
          </tr>
          <tr>
            <td>账号信息</td>
            <td>{{ticketList.accountInfo}}</td>
          </tr>
          <tr>
            <td>服务有效期</td>
            <td>{{ticketList.serviceDate}}</td>
          </tr>
          <tr>
            <td>备注信息</td>
            <td>{{ticketList.description}}</td>
          </tr>
            <tr>
              <td>追加备注</td>
              <td>{{ ticketList.addRemark }}</td>
            </tr>
            <tr>
              <td>退回备注</td>
              <td>{{ ticketList.refundRemark }}</td>
            </tr>
        <tr>
          <td>取消备注</td>
          <td>{{ ticketList.cancelReason }}</td>
        </tr>
        </table>
      </div>
      <div class="orderDetail">
        <div>
          <span>优惠券:</span>
          <span>{{ticketList.couponFee ? ticketList.couponFee : 0}}元</span>
        </div>
        <div>
          <span>服务费:</span>
          <span>{{ticketList.serverFee}}元</span>
        </div>
        <div>
          <span>加价:</span>
          <span>{{ticketList.addFee}}元</span>
        </div>
        <div>
          <span>溢价:</span>
          <span>{{ticketList.premiumFee}}元</span>
        </div>
        <div>
          <span>票价:</span>
          <span>{{ticketList.ticketFee}}元</span>
        </div>
        <div>
          <span>追加费用:</span>
          <span>{{ticketList.addCostFee}}元</span>
        </div>


        <div>
          <span>退回费用:</span>
          <span class="totalPrice">{{ticketList.refundFee}}元</span>
        </div>
        <div class="total">
          <span>合计:</span>
          <span class="totalPrice">{{ticketList.payFee}}元</span>
        </div>
      </div>

       <div class="info" v-if="ticketList.isEvaluate == 1">
        <div class="info_title" style="font-size:30px;margin:30px 0px;">评价</div>
        <table>
          <tr>
            <td>评价内容</td>
            <td>{{ ticketList.evaluateContent }}</td>
          </tr>
          <tr>
            <td>评价星级</td>
            <td>
              <el-rate
                v-model="ticketList.evaluateStar"
                disabled
                show-score
                text-color="#ff9900"
              >
              </el-rate>
            </td>
          </tr>
          <tr>
            <td>评价时间</td>
            <td>{{ ticketList.evaluateDate }}</td>
          </tr>
        </table>
      </div>

    </div>

<el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div  class="info">
       <table>
          <tr>
            <td>姓名</td>
            <td>{{ticketList.name}}</td>
          </tr>
          <tr>
            <td>身份证号码</td>
            <td>{{ticketList.idCard}}</td>
          </tr>
          <tr>
            <td>车次</td>
            <td>{{ticketList.cpTrainNumber}}</td>
          </tr>
          <tr>
            <td>座次</td>
            <td>{{ticketList.cpSeatName}}</td>
          </tr>
          <tr>
            <td>出行日期</td>
            <td>{{ticketList.cpDepartureDate}}</td>
          </tr>
          <tr>
            <td>备注信息</td>
            <td>{{ticketList.cpDescription }}</td>
          </tr>

        </table>
         </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import {reqTicketOrderDetail} from '../../../api'
export default {
  data() {
    return{
      dialogVisible:false,
      ticketList: {}
    }
  },
  created() {
    const {id} = this.$route.query
    reqTicketOrderDetail(id).then(res => {
      console.log(res)
      if(res.code === 200) {
        this.ticketList = res.data.bussData
      }
    })
  },
  methods: {
    handleClose(){
      this.dialogVisible=false
    },
    open(){
      this.dialogVisible=true
    },
    // 投诉
    complain() {
      const {id} = this.$route.query
      this.$router.push({name: 'Complain', query: {id}})
    },
    createdTime1(status) {
      return this.ticketList.createDate
    },
    createdTime2(status) {
      return this.ticketList.accessDate
    },
    createdTime3(status) {
      return this.ticketList.paymentDate
    },
    createdTime4(status) {
      return this.ticketList.evaluateDate
    },
    createdTime5(status) {
      return this.ticketList.finishDate
    },
    createdTime6(status) {
      return this.ticketList.cancelDate
    },
    orderStatus1 (status) {
      return '待支付'
    },
    orderStatus2 (status) {
      return '待抢单'
    },
    orderStatus3 (status) {
      return '进行中'
    },
    orderStatus4 (status) {
      return '待评价'
    },
    orderStatus5 (status) {
      return '已完成'
    },
    orderStatus6 (status) {
      return '已取消'
    },

  }
}
</script>

<style scoped lang="less" type="text/less">
.btn_top{
  margin-left: 50px;
}
.hosOrder{
  h3{
    font-size: 24px;
    margin-top:60px;
    span{
      margin-left: 59px;
      font-size: 16px;
      color:#2FA1DE;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .tail{
    margin-top:29px;
    display: flex;
    p{
      margin-bottom: 15px;
      .time{
        margin-right: 20px;
      }
    }
  }
  .hospital{
    padding-bottom: 30px;
    border-bottom:1px solid #e1e1e1;
    .hos{
      margin-top:27px;
      margin-bottom: 31px;
    }
  }
  .info{
    h5{
      font-size: 16px;
      font-weight: bold;
      margin: 30px 0 20px;
    }
    table{
      /*border:1px solid #e1e1e1;*/
      td{
        border:1px solid #e1e1e1;
        &:first-of-type{
          width: 129px;
          height: 40px;
          line-height: 40px;
          text-indent: 20px;
        }
        &:last-of-type{
          width: 440px;
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          box-sizing: border-box;
        }
        span{
          color: #2fa1de;
          margin-right: 10px;
        }
      }
    }
    .orderDetail{
      width: 569px;
      box-sizing: border-box;
      margin-top:19px;
      padding:30px 30px 20px;
      border:4px solid #f1f1f1;
      div{
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        font-size: 16px;
        &.total{
          span{
            font-size: 20px;
            font-weight: 500;
            &:last-of-type{
              color:#E60012;
            }
          }
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/TicketOrder.vue